import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { CustomTitleService } from '../shared/service/custom-title/custom-title.service';

@Component({
  selector: 'cc-project-home-page',
  templateUrl: 'project-home-page.component.html',
  styleUrls: ['home-page.component.scss'],
})
export class ProjectHomePageComponent implements OnInit, OnDestroy {
  unSubscribe = new Subject<void>();
  projectId;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly location: Location,
    private readonly customTitleService: CustomTitleService,
  ) {}

  ngOnInit() {
    this.route.queryParams
      .pipe(distinctUntilChanged(), takeUntil(this.unSubscribe))
      .subscribe((params: Params) => {
        if (params.fromEmail) {
          this.location.go(this.router.createUrlTree([], { relativeTo: this.route }).toString());
        }
      });

    this.customTitleService.setTitle('Activity - Dashpivot');
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
